import React, { useState } from 'react'
import withClinic from '../hooks/with_clinic';
import { ApolloResult, Clinic, Order, Practitioner, Product, ProductStockItem, Service, } from '../store';
import { Row, Col, Typography, Empty } from 'antd';
import Search from 'antd/lib/input/Search';
import DateRange from '../components/date_range';
import { Form } from 'antd';
import { Table } from 'antd';
import { addDays, format, subDays } from 'date-fns';
import ButtonGroup from 'antd/lib/button/button-group';
import { useQuery } from '@apollo/client';
import LoadingSpinner from '../components/loading_indicator';
import Error from '../components/apollo_error';
import MultiSelect from '../components/multi_select';
import { formatMoney } from '../helpers/utils';
import { Avatar } from 'antd';
import { getPSIVar, get_psi } from '../graphql/product_stock_item';
interface P {
    currentClinic?: Clinic
}

const ProductStockItemPage = (props: P) => {
    const clinicId = props.currentClinic?.id || "";
    // const clinicId = "clhobuntc0002s6019ajmqkcj";
    const [searchText, setSearchText] = useState<string | null>(null);
    const [filter, setFilter] = useState<string[]>([]);
    const [ranges, setRanges] = useState({ startDate: subDays(new Date(), 30), endDate: addDays(new Date(), 15) })
    const [form] = Form.useForm();
    const variables = getPSIVar({ clinicId, startDate: ranges.startDate, endDate: ranges.endDate, searchText, take: 150, status: filter });
    const { loading, data, error } = useQuery<ApolloResult<"productStockItems", Practitioner[]>>(get_psi, { variables })
    if (loading) return <LoadingSpinner />
    if (error) return <Error error={error} />
    if (!data) return <Empty />
    const onDateChange = (startDate: Date, endDate: Date) => {
        setRanges({ startDate, endDate });
    }
    const columns: any[] = [
        {
            title: 'Photo',
            dataIndex: "image",
            key: 'image',
            editable: false,
            render: (v: number, r: ProductStockItem) => {
                return <Avatar src={r.images.length > 0 ? r.images[0] : null} size={50} />;
            },
        },
        {
            title: 'Name',
            dataIndex: "name",
            key: 'name',
            editable: false,
            sorter: (a: ProductStockItem, b: ProductStockItem) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            defaultSortOrder:"ascend"

        },
        {
            title: 'Product',
            dataIndex: "product",
            key: "product",
            editable: false,
            sorter: (a: ProductStockItem, b: ProductStockItem) => a.product.name.toLowerCase().localeCompare(b.product.name.toLowerCase()),
            render: (v: number, r: ProductStockItem) => {
                return r.product.name;
            },
        },
        {
            title: 'Stock',
            dataIndex: "stock",
            key: 'stock',
            sorter: (a: ProductStockItem, b: ProductStockItem) => Number(a.stock) - Number(b.stock),
            editable: false,
        },
        {
            title: 'Price',
            dataIndex: "price",
            key: 'price',
            sorter: (a: ProductStockItem, b: ProductStockItem) => Number(a.price) - Number(b.price),
            editable: true,
        },
        {
            title: 'Original Price',
            dataIndex: "original_price",
            key: 'original_price',
            sorter: (a: ProductStockItem, b: ProductStockItem) => Number(a.original_price) - Number(b.original_price),
            editable: true,
        },
        {
            title: 'CreatedAt',
            dataIndex: "created_at",
            key: 'created_at',
            editable: false,
            sorter: (a: ProductStockItem, b: ProductStockItem) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
            render: (v: ProductStockItem, r: ProductStockItem) => {
                return format(new Date(r.created_at), 'dd MMM,yyyy');
            },
        },
    ];
    const control = (
        <Row style={{ marginTop: -18 }}>
            <Col flex={4}>
                <Row >
                    <Col span={8}>
                        <Typography level={2}>Product Stock Items</Typography>

                    </Col>
                    <Col span={8} offset={8}>
                        <Search
                            defaultValue={searchText || undefined}
                            placeholder="search ...."
                            allowClear
                            size="middle"
                            onSearch={(val: any) => setSearchText(val)}
                        />

                    </Col>
                </Row>
            </Col>
            <Col flex={0}>
                <DateRange startDate={ranges.startDate} endDate={ranges.endDate} onSelect={onDateChange} />
            </Col>
        </Row>
    );
    const context = (
        <Row style={{ marginTop: 8 }}>
            <Col span={24}>
                <Form form={form} component={false}>
                    <Table
                        showHeader={data.productStockItems.length > 0}
                        //components={{ body: { cell: EditableCell, } }}
                        // expandable={{ expandedRowRender, onExpandedRowsChange }}
                        dataSource={data.productStockItems.map(b => ({ key: b.id, ...b }))}
                        columns={columns}
                        rowClassName="editable-row"
                        pagination={false}
                    />
                </Form>
            </Col>
        </Row>
    );
    const filters = (
        <Row style={{ marginTop: 4 }}>
            <Col span={24}>
                <MultiSelect
                    selected={filter}
                    placeholder='Select product status'
                    options={["ACTIVE", "INACTIVE"]}
                    onChange={setFilter} />
            </Col>
        </Row>
    )

    return (
        <React.Fragment>
            {control}
            {filters}
            {context}
        </React.Fragment>
    )
}

export default withClinic(ProductStockItemPage);
